import { Component, inject, OnInit } from '@angular/core';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { IconsModule } from '@bcef/ia-ng-icons';
import { ContextService } from '@bcef/ia-shared';
import { DataLayered } from '@difa/ia-data-layer';
import { WA_LOCATION } from '@ng-web-apis/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

import { TerminationFacade } from '../../termination.facade';

@DataLayered('screens.confirmation.datalayer')
@Component({
  selector: 'ia-resil-contrats-confirmation',
  templateUrl: './confirmation.component.html',
  imports: [IconsModule, TranslateModule, ButtonModule],
})
export class ConfirmationComponent implements OnInit {
  private readonly location: Location = inject(WA_LOCATION);

  private readonly translate: TranslateService = inject(TranslateService);

  private readonly terminationFacade: TerminationFacade = inject(TerminationFacade);

  private readonly contextService: ContextService = inject(ContextService);

  public ngOnInit(): void {
    this.terminationFacade.updateStepInProgress(0);
  }

  public onComplete(): void {
    if (this.contextService.isMobile) {
      this.terminationFacade.closeWebView();
    } else {
      this.translate
        .get('url.urlContract')
        .pipe(take(1))
        .subscribe((url: string) => {
          this.location.href = url;
        });
    }
  }
}
